var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found main-container"},[_c('div',{staticClass:"container--slim"},[_c('h1',[_vm._v(_vm._s(_vm.$t("error_page_not_found_headline")))]),_c('div',[_vm._v(_vm._s(_vm.$t("error_page_not_found_text")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }